import React from 'react'

import { formatPrice } from 'common/utils/format'
import { PRICING } from 'artkive/utils/constants'

import { FreeText, PriceBox, PriceText } from './VirtualGalleryPrice.style'

const VirtualGalleryPrice = () => {
  return (
    <PriceBox>
      <PriceText variant='body1'>{formatPrice(PRICING.virtualGallery.base, 'short')}</PriceText>
      <FreeText variant='body1'>FREE</FreeText>
    </PriceBox>
  )
}

export default VirtualGalleryPrice
